import React from 'react';
import { useTranslation } from 'react-i18next';
import ExclusiveButton from '@wix/da-ds/pkg/Buttons/ExclusiveButton';
import DownloadIcon from '@wix/da-ds/pkg/Icons/24x24/Download';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import useAdoptableState from '../../../AdoptableInfo/useAdoptableState';
import { useExclusiveCategoryTranslation, useResellAction } from '../../hooks';
import Card from '../../lego/Card';
import CardHeading from '../../lego/CardHeading';
import Stack from '../../lego/Stack';
import OwnerRow from '../../lego/OwnerRow';
import ResaleIndicator from '../../lego/ResaleIndicator';
import TradeCount from '../../lego/TradeCount';
import s from './AdoptableSold.scss';
function getSellPrice(deviation) {
    var _deviation_adoptable;
    const { fixedPrice, offers } = (_deviation_adoptable = deviation.adoptable) !== null && _deviation_adoptable !== void 0 ? _deviation_adoptable : {};
    if (offers) {
        return offers.offerPrice;
    } else if (fixedPrice) {
        return fixedPrice.fixedPrice;
    }
}
/**
 * An adoptable specific variant of our exclusive sidebar card. Used only when the exclusive has been sold and is not on sale.
 *
 * NOTE: This component is used for all exclusive types as of this comment's writing. There is no difference spec'd between
 * these cards. Because I don't believe this will stay the case, I architected this in a way to make it easy to make a brand-new
 * sidebar card component.
 *
 * If an exclusive category's card features start to diverge, make a new component instead of putting it in here.
 */ const AdoptableSold = ({ deviation, className })=>{
    var _deviation_extended, _deviation_extended_adoptable, _deviation_extended1;
    const { t } = useTranslation();
    const exclusiveCategoryName = useExclusiveCategoryTranslation(deviation);
    const adoptableState = useAdoptableState(deviation);
    const { isResellOptionPresent, isResellOptionEnabled, isSeller, saleCount } = adoptableState;
    const [resellAction, resellBiData] = useResellAction(deviation, adoptableState);
    var _deviation_extended_adoptable1;
    const { isOwner, assetSourceUrl, owner, lastTradeTs, wasGifted } = (_deviation_extended_adoptable1 = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.adoptable) !== null && _deviation_extended_adoptable1 !== void 0 ? _deviation_extended_adoptable1 : {};
    const downloadLink = isOwner && assetSourceUrl;
    const sellPrice = getSellPrice(deviation);
    return /*#__PURE__*/ React.createElement(Card, {
        badgeType: "adoptable",
        className: className
    }, /*#__PURE__*/ React.createElement(Stack, {
        gap: 16
    }, /*#__PURE__*/ React.createElement(CardHeading, null, exclusiveCategoryName), owner && lastTradeTs && /*#__PURE__*/ React.createElement(OwnerRow, {
        user: owner,
        sellPrice: sellPrice,
        sellTimestamp: lastTradeTs,
        wasGifted: wasGifted
    }), isSeller && /*#__PURE__*/ React.createElement(ResaleIndicator, {
        isResellable: !!((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended1.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : _deviation_extended_adoptable.resaleAllowed)
    }), !isSeller && !!saleCount && /*#__PURE__*/ React.createElement(TradeCount, {
        deviation: deviation,
        count: saleCount,
        className: s['trade-count']
    }), downloadLink && /*#__PURE__*/ React.createElement(ExclusiveButton, {
        priority: "secondary",
        href: downloadLink
    }, /*#__PURE__*/ React.createElement(DownloadIcon, {
        size: IconSize.MEDIUM,
        disableDefaultColors: true,
        className: s['download-icon']
    }), t('sidebar.exclusives.buttons.download')), isResellOptionPresent && isResellOptionEnabled && /*#__PURE__*/ React.createElement(ExclusiveButton, {
        priority: "primary",
        onClick: resellAction,
        biData: resellBiData
    }, t('sidebar.exclusives.buttons.sell'))));
};
AdoptableSold.displayName = 'AdoptableSold';
export default AdoptableSold;
